import type { DocCategoryNode } from "@/lib/document/categoryTypes";

type Props = {
  nodes: DocCategoryNode[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  depth?: number;
};

export function DocumentCategoryTree({ nodes, selectedId, onSelect, depth = 0 }: Props) {
  if (nodes.length === 0 && depth === 0) {
    return (
      <p className="text-sm text-gray-500 dark:text-zinc-400">
        No categories yet. Default folders appear on first load.
      </p>
    );
  }

  return (
    <ul
      className={
        depth === 0
          ? "space-y-1"
          : "mt-1 space-y-1 border-l border-gray-100 pl-3 dark:border-zinc-700"
      }
    >
      {nodes.map((node) => {
        const selected = selectedId === node.id;
        return (
          <li key={node.id}>
            <button
              type="button"
              onClick={() => onSelect(node.id)}
              className={[
                "flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm transition",
                selected
                  ? "bg-indigo-50 font-medium text-indigo-900 dark:bg-indigo-950/40 dark:text-indigo-100"
                  : "text-gray-800 hover:bg-gray-50 dark:text-zinc-200 dark:hover:bg-zinc-800/60",
              ].join(" ")}
            >
              <span className="min-w-0 truncate">{node.name}</span>
              {node.is_system_default ? (
                <span className="shrink-0 text-[10px] uppercase tracking-wide text-gray-400 dark:text-zinc-500">
                  default
                </span>
              ) : null}
            </button>
            {node.children.length > 0 ? (
              <DocumentCategoryTree
                nodes={node.children}
                selectedId={selectedId}
                onSelect={onSelect}
                depth={depth + 1}
              />
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
